import { render } from "./HeadDetails.vue?vue&type=template&id=042a4062&scoped=true"
import script from "./HeadDetails.vue?vue&type=script&lang=js"
export * from "./HeadDetails.vue?vue&type=script&lang=js"

import "./HeadDetails.vue?vue&type=style&index=0&id=042a4062&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042a4062"]])

export default __exports__